import { SET_ITEMS, ADD_ITEM, REMOVE_ITEM } from '../actions/types';
import { ITEMS_ORDER } from '../constants';

export default function items(state = [], action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_ITEMS:
				return action.payload;

			case ADD_ITEM: {
				const newItem = action.payload;
				const index = state.findIndex((item) => item.name === newItem.name);

				let newState;
				if (index !== -1) {
					newState = [...state];
					newState[index] = newItem;
				} else {
					newState = [...state, newItem];
				}

				return newState.sort((a, b) => {
					return ITEMS_ORDER.indexOf(a.name) - ITEMS_ORDER.indexOf(b.name);
				});
			}

			case REMOVE_ITEM:
				return state.filter((item) => item.name !== action.payload);

			// no default
		}
	}

	return state;
}
